import { log2 } from "./log2";
import CONFIG from "../config/config";
import moment from "moment";

const showChildrenState = {};
const log = log2("Menu");
export default (that) => {
    return [
        {
            superAdminPageKey: "cluster-dashboard",
            title: "Cluster Dashboard",
            path: "/cluster-dashboard",
            icon: "cluster-dashboard",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "announcements",
            title: that.$t("announcements.menu"),
            path: "/announcements",
            icon: "clipboard-list",
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "coupons",
            title: that.$t("coupon.coupons"),
            path: "/coupons",
            icon: "Coupon",
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "invoices",
            title: "Invoices",
            path: "/invoices",
            icon: "CreditCard",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "admin-users",
            title: that.$t("adminUser.adminUsers"),
            path: "/admin-users",
            icon: "users",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "sites",
            title: that.$t("message.sites"),
            path: "/sites",
            icon: "site",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "global-settings",
            title: that.$t("message.globalSettings"),
            path: "/global-settings",
            icon: "cogs",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "plan-management",
            title: "Plan Management",
            path: "/plans",
            icon: "SubscriptionIcon",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "error-reports",
            title: that.$t("message.feedback"),
            path: "/ErrorReports",
            icon: "cogs",
            antIcon: "bug",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-chat",
            title: "Chat",
            path: "/chat",
            icon: "comments",
            permission: "chat.get",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-chatbot",
            title: "ChatBot",
            path: "/chatbot/stories",
            icon: "chatbot",
            permission: "chatbot.stories.view",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-visitors",
            title: that.$t("billing.Contacts"),
            path: "/visitors",
            icon: "ContactsIcon",
            permission: "visitor.list.view",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-mails",
            title: "Mailler",
            path: "/mails",
            icon: "MailIcon",
            permission: "",
            showChildren: false,
            enabled: true,
        },
        {
            title: "Calendar",
            path: `/calendar/d/${moment().format().split("T")[0]}`,
            icon: "CalendarIcon",
            permission: "",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-tasks",
            title: "Task",
            path: "/tasks",
            icon: "TaskIcon",
            permission: "",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-ticket",
            title: "Ticket",
            path: "/ticket",
            icon: "ticket",
            permission: ["offlineSupportRequest.get", "ticket"],
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-archive",
            title: that.$t("message.archive"),
            path: "/archives",
            icon: "history",
            permission: "archives.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.tags"),
            path: "/tags",
            icon: "tags",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.offlineSupportRequests"),
            path: "/offline-support-requests",
            icon: "offline-support",
            permission: "offlineSupportRequest.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.roles"),
            path: "/roles",
            icon: "masks",
            permission: "role.get",
            showChildren: false,
            enabled: false,
        },
        {
            superAdminPageKey: "customer-users",
            title: that.$t("message.users"),
            path: "/users",
            icon: "users",
            permission: "user.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.bannedVisitors"),
            path: "/banned-visitors",
            icon: "user-slash",
            permission: "bannedVisitor.view",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.departments"),
            path: "/departments",
            icon: "clipboard-list",
            permission: "topic.get",
            showChildren: false,
            enabled: false,
        },
        {
            superAdminPageKey: "customer-content",
            title: that.$t("message.contents"),
            path: "/templates",
            icon: "box-open",
            permission: "prepared.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.welcomeMessages"),
            path: "/system-messages",
            icon: "hand-paper",
            permission: "welcome.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.catalogCategories"),
            path: "/catalog",
            icon: "Catalog",
            permission: "catalog.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.bannedWords"),
            path: "/forbidden-inputs",
            icon: "ban",
            permission: "bannedWord.get",
            showChildren: false,
            enabled: false,
        },
        {
            superAdminPageKey: "customer-trigger",
            title: that.$t("message.triggers"),
            path: "/triggers",
            icon: "trigger",
            permission: "trigers.view",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.getApps"),
            path: "/supsis-app",
            icon: "apps",
            permission: "",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-settings",
            title: that.$t("message.settings"),
            path: "/settings",
            icon: "cogs",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-integrations",
            title: that.$t("message.integrations"),
            path: "/integrations",
            antIcon: "share-alt",
            permission: "integrations.view",
            showChildren: false,
            enabled: true,
        },

        //instegram özelliği menüden kaldırıldı düzeltildiğinde eklenecek
        //   title: "Instagram",
        //             path: "/integrations/instagram",
        //             icon: "instagram",
        //             permission: "integrations.instagram.view",
        //             showChildren: false,
        //             enabled: CONFIG.INSTAGRAM.ENABLED,
        {
            superAdminPageKey: "customer-billing",
            title: that.$t("billing.billingPlanSettings"),
            path: "/billing",
            icon: "CreditCard",
            permission: "billing.read",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-report",
            title: that.$t("report.reports"),
            path: "/report-new",
            icon: "DetailReports",
            permission: "report.get",
            enabled: true,
        },
    ];
};

export const toggleShowChildren = (path) => {
    log("toggleShowChildren called", path);
    if (showChildrenState[path] !== undefined) {
        showChildrenState[path] = !showChildrenState[path];
    } else {
        showChildrenState[path] = true;
    }
};
